import { render, staticRenderFns } from "./BusinessForm.vue?vue&type=template&id=24ecab46&scoped=true"
import script from "./BusinessForm.vue?vue&type=script&lang=js"
export * from "./BusinessForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessForm.vue?vue&type=style&index=0&id=24ecab46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ecab46",
  null
  
)

export default component.exports